const Footer = () => (
    <footer className="bg-gray-800 text-white p-4">
      <div className="container mx-auto text-center">
        <p>&copy; 2024 HackHub. All rights reserved.</p>
      </div>
    </footer>
  );
  
  export default Footer;
  